import { AuthResponseCode } from '../../../auth/constants/auth-response-code.enum';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../shared/common/common.service';
import { AuthService } from '../../../auth/auth.service';
import { UserService } from '../../../auth/users/user.service';
import { CustomValidators } from 'ng2-validation';
import { AuthResponse } from '../../../auth/models/auth-response.model';
import { ConsoleLogger } from '../../../core/utilities/console-logger';
import { LocalStorageKeys } from '../../../core/constants/localStorageKeys.enum';

@Component({
  selector: 'app-test-external-login',
  templateUrl: './test-external-login.component.html',
  styleUrls: ['./test-external-login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TestExternalLoginComponent implements OnInit, AfterViewInit {
  @ViewChild("usernameField") usernameField : ElementRef;
  @ViewChild("passwordField") passwordField : ElementRef;
  @ViewChild('areaCodeInput') areaCodeInput: ElementRef;
  @ViewChild('exchangeInput') exchangeInput: ElementRef;
  @ViewChild('lineNumberInput') lineNumberInput: ElementRef;

  public form: FormGroup;
  public UserName: AbstractControl;
  public UserPassword: AbstractControl;
  public MfaCode: AbstractControl;
  public NewPhoneNumber: AbstractControl;
  public SmsConsent: AbstractControl;
  public isLoading = false;
  public saveUsername = false;
  public errorMessage: string;
  public phoneSuffix: string;

  public showLogin = true;
  public showCode = false;
  public showPhone = false;
  public showSuccess = false;
  public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private commonService: CommonService,
    private authService: AuthService,
    private userService: UserService
  ) {
    this.form = this.fb.group({
      'UserName': ['', Validators.compose([Validators.required, CustomValidators.UserName])],
      'UserPassword': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      'MfaCode': [''],
      'NewPhoneNumber': [''],
      'SmsConsent': [false]
    });

    this.UserName = this.form.controls['UserName'];
    this.UserPassword = this.form.controls['UserPassword'];
    this.MfaCode = this.form.controls['MfaCode'];
    this.NewPhoneNumber = this.form.controls['NewPhoneNumber'];
    this.SmsConsent = this.form.controls['SmsConsent'];
  }

  ngOnInit() {

  }

  public onSubmit(): void {
    this.errorMessage = '';
    this.authService.clearAuthSession();

    if (this.form.valid) {
      this.isLoading = true;
      document.getElementById('preloader').classList.remove('hide');
      if(!this.form.value.NewPhoneNumber){
        this.submitLogin();

      }else{
        this.submitNewPhone();
      }
    }
  }

  private async submitLogin() {
    this.errorMessage = "";
    try {
      const authResponse = await this.authService
        .loginWithUserNamePassword(this.form.value.UserName, this.form.value.UserPassword, this.form.value.MfaCode);

      switch (authResponse.responseCode) {
        case AuthResponseCode.MFA_CODE_SENT:
          if(authResponse.mfaPhoneSuffix) {
            this.phoneSuffix = authResponse.mfaPhoneSuffix;
          }

          this.showLogin = false;
          this.showCode = true;
          this.showPhone = false;
          document.getElementById('preloader').classList.add('hide');
          this.isLoading = false;
          return;
        case AuthResponseCode.MFA_SETUP_REQUIRED:
          this.showLogin = false;
          this.showCode = false;
          this.showPhone = true;
          document.getElementById('preloader').classList.add('hide');
          this.isLoading = false;
          return;
        case AuthResponseCode.AUTH_SUCCESS:
          this.showLogin = false;
          this.showCode = false;
          this.showPhone = false;
          this.showSuccess = true;
          document.getElementById('preloader').classList.add('hide');
          this.isLoading = false;
          return;
        default:
          throw new Error('Unknown Response');
      }
    } catch (err) {
      console.error('error', err);
      this.errorMessage = err.error;
    } finally {
      document.getElementById('preloader').classList.add('hide');
      this.isLoading = false;
    }
  }

  private submitNewPhone(){
    const newPhoneNumber = this.form.value.NewPhoneNumber.replace(/\D/g, '');
    if(newPhoneNumber.length == 10){
      this.phoneSuffix = newPhoneNumber.slice(-4)
      this.userService.setMfaPhoneNumber(this.form.value.UserName, this.form.value.UserPassword, newPhoneNumber, this.form.value.MfaCode)
        .toPromise()
        .then((resp) => {
          if(resp.message == "CodeSent"){
            this.showLogin = false;
            this.showCode = true;
            this.showPhone = false;
            document.getElementById('preloader').classList.add('hide');
            this.isLoading = false;
          }
          if(resp.message == "ConfirmedNewPhone"){
            this.showLogin = false;
            this.showCode = false;
            this.showPhone = false;
            this.showSuccess = true;
            document.getElementById('preloader').classList.add('hide');
            this.isLoading = false;
          }

        },(err) => {
          console.error('error', err)
          this.errorMessage = err.error;
          document.getElementById('preloader').classList.add('hide');
          this.isLoading = false;
      })
    }else{
      this.errorMessage = "Phone number must be a 10 digit number.";
      document.getElementById('preloader').classList.add('hide');
      this.isLoading = false;
    }
  }

  private restoreUsername() {
    const username = localStorage.getItem(LocalStorageKeys.SAVED_USERNAME);

    if (username) {
      this.UserName.patchValue(username);
      this.saveUsername = true;
      this.passwordField.nativeElement.focus();
      return;
    }

    this.usernameField.nativeElement.focus();
  }

  private saveUsernameToLocalStorage() {
    if (this.saveUsername) {
      localStorage.setItem(LocalStorageKeys.SAVED_USERNAME, this.UserName.value)
    } else {
      localStorage.removeItem(LocalStorageKeys.SAVED_USERNAME);
    }
  }

  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
  }

  public startOver(){
    this.errorMessage = "";
    this.phoneSuffix = "";
    this.showLogin = true;
    this.showCode = false;
    this.showPhone = false;
    this.showSuccess = false;
    this.form.patchValue({
      'MfaCode': '',
      'NewPhoneNumber': '',
      'SmsConsent': false
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/developer/components/test-external-login/test-external-login.component.ts